import React__default, { useContext, useMemo } from 'react';
import { L as Label, a as LabelTypography, b as LabelColors } from '../chunks/bundle-ZBp236Ey.js';
import { y as getClassName, e as isEditedMessage } from '../chunks/bundle-EMEHizdG.js';
import { L as LocalizationContext } from '../chunks/bundle-BSUtC3cw.js';
import { t as tokenizeMessage } from '../chunks/bundle-CSKhnQl7.js';
import { T as TextFragment } from '../chunks/bundle-CclIyWE2.js';
import { T as TEXT_MESSAGE_BODY_CLASSNAME } from '../chunks/bundle-xdZcjYxt.js';
import '../chunks/bundle-j5GfJ6DZ.js';
import '../chunks/bundle-BjDPDV1u.js';
import '@sendbird/chat/groupChannel';
import '../utils/message/getOutgoingMessageState.js';
import '../chunks/bundle-Bzoj1u3h.js';
import '../chunks/bundle-Cj_4CfJM.js';
import '../chunks/bundle-RVsnVYbw.js';
import '../chunks/bundle-C6g3HNED.js';
import '../chunks/bundle-CnQtgeX8.js';
import '../Message/context.js';
import './MentionLabel.js';
import '../chunks/bundle-BB95aNhx.js';
import 'react-dom';
import '../chunks/bundle-idC_wVZi.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import './SortByRow.js';
import '../chunks/bundle-B7LMd75S.js';
import './IconButton.js';
import '../chunks/bundle-BC1GKYVu.js';
import './UserProfile.js';
import '../chunks/bundle-S7XE7Lfi.js';
import '../chunks/bundle-DloqDvm2.js';
import '../sendbirdSelectors.js';
import '../chunks/bundle-u2dy86rx.js';
import '../chunks/bundle-2OseAMr7.js';
import './ImageRenderer.js';
import '../chunks/bundle-BlgLvEI8.js';
import './Icon.js';
import './Button.js';
import './LinkLabel.js';

function TextMessageItemBody(_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, message = _a.message, _d = _a.isByMe, isByMe = _d === void 0 ? false : _d, _e = _a.mouseHover, mouseHover = _e === void 0 ? false : _e, _f = _a.isMentionEnabled, isMentionEnabled = _f === void 0 ? false : _f, _g = _a.isReactionEnabled, isReactionEnabled = _g === void 0 ? false : _g, _h = _a.isMarkdownEnabled, isMarkdownEnabled = _h === void 0 ? false : _h;
    var stringSet = useContext(LocalizationContext).stringSet;
    var isMessageMentioned = isMentionEnabled
        && (message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate)
        && message.mentionedMessageTemplate.length > 0
        && (message === null || message === void 0 ? void 0 : message.mentionedUsers)
        && message.mentionedUsers.length > 0;
    var tokens = useMemo(function () {
        var _a;
        if (isMessageMentioned) {
            return tokenizeMessage({
                mentionedUsers: (_a = message === null || message === void 0 ? void 0 : message.mentionedUsers) !== null && _a !== void 0 ? _a : undefined,
                messageText: message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate,
                includeMarkdown: isMarkdownEnabled,
            });
        }
        return tokenizeMessage({
            messageText: message === null || message === void 0 ? void 0 : message.message,
            includeMarkdown: isMarkdownEnabled,
        });
    }, [message === null || message === void 0 ? void 0 : message.updatedAt, message === null || message === void 0 ? void 0 : message.message]);
    return (React__default.createElement(Label, { type: LabelTypography.BODY_1, color: isByMe ? LabelColors.ONCONTENT_1 : LabelColors.ONBACKGROUND_1 },
        React__default.createElement("div", { className: getClassName([
                className,
                TEXT_MESSAGE_BODY_CLASSNAME,
                isByMe ? 'outgoing' : 'incoming',
                mouseHover ? 'mouse-hover' : '',
                (isReactionEnabled && ((_b = message === null || message === void 0 ? void 0 : message.reactions) === null || _b === void 0 ? void 0 : _b.length) > 0) ? 'reactions' : '',
            ]) },
            React__default.createElement(TextFragment, { tokens: tokens }),
            isEditedMessage(message) && (React__default.createElement(Label, { className: "sendbird-text-message-item-body__message edited", type: LabelTypography.BODY_1, color: isByMe ? LabelColors.ONCONTENT_2 : LabelColors.ONBACKGROUND_2 }, " ".concat(stringSet.MESSAGE_EDITED, " "))))));
}

export { TextMessageItemBody as default };
//# sourceMappingURL=TextMessageItemBody.js.map
